import * as Styled from "../EditUploadPhotoModal/EditUploadPhotoModal.styles";
import BaseModal from "../BaseModal/BaseModal";
import { Box, Button } from "@mui/material";
import { ChipListInput, Input } from "../../components";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { useTheme } from "@mui/material";

type EditUploadPhotoModalProps = {
    open: any;
    onClose: any;
    handleCaptionChange: (photoIndex: number, caption: string) => void;
    photoIndex: number;
    image: any;
    imageName: string;
};

const EditUploadPhotoModal = ({
    open,
    onClose,
    handleCaptionChange,
    photoIndex,
    image,
    imageName,
}: EditUploadPhotoModalProps) => {
    const theme = useTheme();

    const formMethods = useForm({
        defaultValues: {
            tags: [],
            caption: "",
        },
        mode: "onChange",
    });

    const onCaptionSubmit: SubmitHandler<{ caption: string }> = (data) => {
        handleCaptionChange(photoIndex, data.caption);
        formMethods.reset();
        onClose();
    };

    return (
        <BaseModal open={open} onClose={onClose} overflow="scroll">
            <FormProvider {...formMethods}>
                <form onSubmit={formMethods.handleSubmit(onCaptionSubmit)}>
                    <Box>
                        {" "}
                        <Styled.ImageName
                            fontWeight={700}
                            marginBottom="24px"
                            marginRight="8px"
                            variant="modalBody"
                        >
                            {imageName}
                        </Styled.ImageName>
                        <Styled.Image
                            alt={`Uploaded ${photoIndex}`}
                            src={image}
                        />
                        <Input
                            name="caption"
                            control={formMethods.control}
                            label={"Photo Caption"}
                            required
                            placeholder="Enter caption..."
                            fullWidth
                        />
                        <ChipListInput
                            name={"tags"}
                            control={formMethods.control}
                            label={"Tags"}
                            placeholder="Start typing a name..."
                            fullWidth
                        />
                        <Box
                            display="flex"
                            marginTop="24px"
                            justifyContent="end"
                        >
                            <Button
                                variant="contained"
                                type="submit"
                                sx={{
                                    [theme.breakpoints.down("tablet")]: {
                                        width: "100%",
                                    },
                                }}
                            >
                                Save
                            </Button>
                        </Box>
                    </Box>
                </form>
            </FormProvider>
        </BaseModal>
    );
};

export default EditUploadPhotoModal;
